<template>
  <div>
    <div class="w3-row">
      <div class="w3-col s12 m8">
        <div class="sectionHeader" style="text-align:center;">
          <h5>Billing Details</h5>
        </div>
        <div class="whiteContainer">
          <div class="w3-row">
            <div class="w3-col s12 m6">
              <input class="w3-input w3-border" style="margin-bottom:8px;" placeholder="First Name" v-model="selectedAd.billing.firstName" />
            </div>
            <div class="w3-col s12 m6">
              <input class="w3-input w3-border" style="margin-bottom:8px;" placeholder="Last Name" v-model="selectedAd.billing.lastName" />
            </div>
          </div>
          <input class="w3-input w3-border w3-margin-bottom" placeholder="Company" v-model="selectedAd.billing.company" />
          <input class="w3-input w3-border w3-margin-bottom" placeholder="Street Address" v-model="selectedAd.billing.street" />
          <div class="w3-row">
            <div class="w3-col s12 m4 w3-margin-bottom">
              <input class="w3-input w3-border" placeholder="City" v-model="selectedAd.billing.city" />
            </div>
            <div class="w3-col s12 m4 w3-margin-bottom">
              <input class="w3-input w3-border" placeholder="State" v-model="selectedAd.billing.state" />
            </div>
            <div class="w3-col s12 m4 w3-margin-bottom">
              <input class="w3-input w3-border" placeholder="Zip" v-model="selectedAd.billing.zip" />
            </div>
          </div>
        </div>

        <div class="w3-row w3-margin-bottom">
          <div class="sectionHeader" style="text-align:center;">
            <h5>Invoice</h5>
          </div>
          <div class="w3-card-4 whiteContainer">
            <div class="w3-row w3-font-16">
              <div class="w3-col s12 m6 w3-padding">
                <header>
                  <h5 style="margin:8px 0 0;">Bill To</h5>
                </header>
                <section>    
                  <span>{{selectedAd.billing.firstName}} {{selectedAd.billing.lastName}}<br/></span>
                  <span v-if="selectedAd.billing.company !== ''">{{selectedAd.billing.company}}<br/></span>
                  <span>{{selectedAd.billing.street}}<br/></span>
                  <span v-if="selectedAd.billing.city !== '' || selectedAd.billing.state !== '' || selectedAd.billing.zip !== ''">{{selectedAd.billing.city}}, {{selectedAd.billing.state}}&nbsp;&nbsp;{{selectedAd.billing.zip}}</span>
                </section>
              </div>
              <div class="w3-col s12 m6 w3-padding">
                <header>
                  <h5 style="margin:8px 0 0;">Pay To</h5>
                </header>
                <section>
                  <span>DaytonaLocal.com<br/>PO Box 123<br/>Ormond Beach, FL 32174</span>
                </section>
              </div>
            </div>
            <div class="w3-row w3-margin-top">
              <table class="w3-table w3-bordered paymentMethodResults">
                <tr style="background:#424242; color:#fafafa;">
                  <th>Item</th>
                  <th class="w3-center" style="width:200px;">Period</th>
                  <th class="w3-center" style="width:90px;">Price</th>
                </tr>
                <tr>
                  <td>{{selectedAd.placement | capitalize()}} Ad - {{selectedAd.title}}</td>
                  <td class="w3-center">
                    <span>{{selectedAd.start | date('shortDate')}} - {{selectedAd.end | date('shortDate')}}</span>
                  </td>
                  <td class="w3-center" style="font-weight:400;">{{selectedAd.billing.cost / 100 | currency}}</td>
                </tr>
              </table>
            </div>
            <div class="w3-row w3-margin-top">
              <div class="w3-padding w3-right-align w3-font-20">
                <span style="margin-right:10px;">Total:</span><span style="font-weight:400;">{{selectedAd.billing.cost / 100 | currency}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="w3-col s12 m4">
        <div class="sectionHeader" style="text-align:center;">
          <h5>Payment Method</h5>
        </div>
        <div class="whiteContainer">
          <div class="w3-center">
            <paymentMethods wideLayout="true"></paymentMethods>
          </div>
        </div>
        <div class="sectionHeader" style="text-align:center;">
          <h5>Checkout</h5>
        </div>
        <div class="whiteContainer">
          <div class="w3-row">
            <div class="w3-col s12 m9" :style="width < 601 ? 'text-align:center;' : ''">{{selectedAd.placement | capitalize()}} Ad ({{selectedAd.start | date('shortDate')}} - {{selectedAd.end | date('shortDate')}})</div>
            <div class="w3-col s12 m3 w3-right" style="font-weight:400;" :style="width < 601 ? 'text-align:center;' : 'text-align:right;'">
              <template v-if="selectedAd.paid">
                Paid
              </template>
              <template v-if="!selectedAd.paid">
                {{selectedAd.billing.cost / 100 | currency()}}
              </template>
            </div>
          </div>
        </div>
        <template v-if="paymentError && paymentError !== ''">
          <div class="whiteContainer w3-center">
            <p style="color:#c62828;">{{paymentError}}</p>
          </div>
        </template>
        <div style="margin:0 4px;">
          <button class="w3-button w3-green w3-block" style="margin-bottom:8px;" @click="$emit('purchaseAd')">
            <template v-if="selectedAd.paid">
              Save Changes
            </template>
            <template v-if="!selectedAd.paid">
              Finish & Pay
            </template>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import * as moment from 'moment'
  import paymentMethods from '@/components/paymentMethods.vue'

  export default {
    name: 'billing',
    props: ['paymentError'],
    data() {
      return {
        width: window.innerWidth
      }
    },
    components: {
      paymentMethods,
    },
    computed: {
      ...mapState([
        'selectedAd'
      ])
    },
    mounted() {
      if (this.selectedAd.paid) {
        console.log('already paid')
      }
    }
  }
</script>

<style scoped>
</style>
